import { Add, Cancel, Done, DoneAll, Save, Send, UploadRounded } from '@mui/icons-material';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Typography, IconButton, Skeleton, Collapse, AlertColor, CircularProgress } from '@mui/material';
import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import Message from '../Message';
import Hash from '../../Functions/Security/Hash';
import Data from "../../Data/Data.json"
import { Crypter } from '../../Functions/Security/Crypter';
import axios from 'axios';
import SweetAlert from "sweetalert2"


export default function UpdatePassword(props:{name : string, f? : any}) {
  const [open, setOpen] = React.useState(true);
  const [isOk, setIsOk] = useState(false);

  const formSchema = Yup.object().shape({
    oldpassword: Yup.string()
    .required('Old password is mendatory')
    .min(8, 'Old Password must be at 8 char long'),
    newpasword: Yup.string()
      .required('New password is mendatory')
      .min(8, 'Password must be at 8 char long')
      .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
      ),
    confirmPwd: Yup.string()
      .required('Confirm password is mendatory')
      .oneOf([Yup.ref('newpasword')], 'Passwords does not match')
  })
  const formOptions = { resolver: yupResolver(formSchema) }
  const {register, handleSubmit, formState } = useForm(formOptions)
  const methods = useForm();
  
  const[load, setLoad] = useState(false);
  const[showMessage, setShowMessage] = useState(false);
  const[message, setMessage] = useState("");
  const[typeMessage, setTypeMessage] = useState<AlertColor>("error");
  
  
  const { errors } = formState

  const handleClickOpen = () => {
    setOpen(true);
    if (props.f) {
      props.f(true)
    }
  };
  const handleClose = () => {
    setOpen(false);
    if (props.f) {
      props.f(false)
    }
  };
  
  // Intervale de visibilité du message
  if(showMessage && !isOk){
    setTimeout(()=>{
        setShowMessage(false)
    }, 10000)
}

  const onSubmit = async (data : any) =>{
      
    setLoad(true)

    let pass = Hash(data["newpasword"])
    let oldpass = Hash(data["oldpassword"])
    data = {"coduti": props.name.split("-")[0], "motpas": pass, "encienmotpas": oldpass}
    // console.log(Crypter.encrypt(JSON.stringify(data)))
    let config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.setPassword,
        headers: { 
            'CipherUser': Crypter.encrypt(JSON.stringify(data)),
            'Authorization': Data.SecretKey.ApiToken
          },
    };

    axios.request(config)
    .then((response) => {
      if(response.data){
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        if(res.StatutCode == 200){

          setMessage(res.Message+"")
          setTypeMessage("success")

          //setIsOk(true)

          setOpen(false)
          SweetAlert.fire({title: "Modification mot de passe", text : res.Message+"", timer : 5000, icon: "success"})
          
          if (props.f) {
            props.f()
          }
          

          // setTimeout(()=>{
          //   setOpen(false)
          // }, 5000)
        }
        else{
            setMessage(res.Message+"")
            setTypeMessage("error")
        }
        setShowMessage(true)
        setLoad(false)
    }
        console.log(JSON.stringify(response.data));
        setLoad(false)
    })
    .catch((error) => {
      setMessage(error.message)
      setTypeMessage("error")
      setShowMessage(true)
        setLoad(false)
    });

}



  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
    <DialogContent>
        
    <FormProvider {...methods}>
    <form className='form' onSubmit={handleSubmit(onSubmit)}>
        
    <Typography variant='h5' >{props.name.split('|||')[1]? props.name.split('|||')[1] : props.name}</Typography>
    {!isOk?
    <><Typography variant='subtitle1' color={'GrayText'} >Veillez remplir ces champs pour modifier votre mot de passe</Typography></>
    :
    ""}
    <br />
    <Collapse sx={{ width: '100%' }} in = {showMessage}>
      <Message Message={message} type={typeMessage} />
    </Collapse>
      {

        !isOk? 
        <>
          <TextField
        type={"password"}
        {...register("oldpassword")}
        required
        id="outlined-multiline-static"
        label={'Old Password'}
        placeholder={"Enter Old Password"}
        helperText={errors.oldpassword != undefined? errors.oldpassword.message+"": ""}
        variant="filled"
        fullWidth
        color='success' />
    <TextField
        type={"password"}
        {...register("newpasword")}
        required
        id="outlined-multiline-static"
        label={'New Password'}
        placeholder={"Enter New Password"}
        helperText={errors.newpasword != undefined? errors.newpasword.message+"": ""}
        variant="filled"
        fullWidth
        color='success' />
    <TextField
        type={"password"}
        {...register("confirmPwd")}
        required
        id="outlined-multiline-static"
        label={'Confirm Password'}
        placeholder={"Enter Confirm Password"}
        helperText={errors.confirmPwd != undefined? errors.confirmPwd.message+"": ""}
        variant="filled"
        fullWidth
        color='success' />
        <br />
        <br />
        </>
        
        :
        ""
      }
        <DialogActions>
        <Button onClick={handleClose} variant='outlined' color="error" startIcon={<Cancel />}>
        {!isOk? 'Cancel' !: 'Close'}
        </Button>
        {!isOk?

        <>
          {
          load? 
          <Button type='submit' color="success" variant='outlined' disabled startIcon={<CircularProgress size={20} color={'inherit'} />}>
              Save
          </Button>
          :
          <Button type='submit' color="success" variant='outlined'>
              Save
          </Button>
          }
        </>
          :
          ""
        }
    </DialogActions>
            </form>
        </FormProvider>
    </DialogContent>
    </Dialog>

  );
}
